/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Referral_ProgramInputs */

const en_dashboard_referral_program = /** @type {(inputs: Dashboard_Referral_ProgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referral Program`)
};

const de_dashboard_referral_program = /** @type {(inputs: Dashboard_Referral_ProgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empfehlungsprogramm`)
};

const fr_dashboard_referral_program = /** @type {(inputs: Dashboard_Referral_ProgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme de parrainage`)
};

const es_dashboard_referral_program = /** @type {(inputs: Dashboard_Referral_ProgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programa de referidos`)
};

const it_dashboard_referral_program = /** @type {(inputs: Dashboard_Referral_ProgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programma referral`)
};

const nl_dashboard_referral_program = /** @type {(inputs: Dashboard_Referral_ProgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijzingsprogramma`)
};

const pl_dashboard_referral_program = /** @type {(inputs: Dashboard_Referral_ProgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program polecen`)
};

const fi_dashboard_referral_program = /** @type {(inputs: Dashboard_Referral_ProgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suositteluohjelma`)
};

const da_dashboard_referral_program = /** @type {(inputs: Dashboard_Referral_ProgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henvisningsprogram`)
};

const sv_dashboard_referral_program = /** @type {(inputs: Dashboard_Referral_ProgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haenvisningsprogram`)
};

/**
* | output |
* | --- |
* | "Referral Program" |
*
* @param {Dashboard_Referral_ProgramInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_referral_program = /** @type {((inputs?: Dashboard_Referral_ProgramInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Referral_ProgramInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_referral_program(inputs)
	if (locale === "fr") return fr_dashboard_referral_program(inputs)
	if (locale === "es") return es_dashboard_referral_program(inputs)
	if (locale === "it") return it_dashboard_referral_program(inputs)
	if (locale === "nl") return nl_dashboard_referral_program(inputs)
	if (locale === "pl") return pl_dashboard_referral_program(inputs)
	if (locale === "fi") return fi_dashboard_referral_program(inputs)
	if (locale === "da") return da_dashboard_referral_program(inputs)
	if (locale === "sv") return sv_dashboard_referral_program(inputs)
	return en_dashboard_referral_program(inputs)
});